<template >

  <!--justify-space-around align-content-space-between-->

  <v-flex   xs12 sm12 md12 lg12  pt-2 row--dense  shsIndexBg>


    <v-flex :class="['xs12 sm12 md12 lg12 justify-start align-self-start',$vuetify.breakpoint.smAndDown?'':'shsUpBg']"   :style="{textAlign: $vuetify.breakpoint.smAndDown?'text-center':'text-left',marginTop:'-10px'}">
      <!--  src="../../../assets/images/indexSHS/.png"-->
      <v-img
          v-show="$vuetify.breakpoint.smAndDown"
          src="../../../assets/images/indexSHS/handsFull.png"
          contain>

        <v-btn
            fab
            middle
            right
            light
            top
            style="float: right"
            class="ml-2 mt-2 mr-2"
            @click="goClinicNo('DoctorIntroduction')"
        >
          <img  src="../../../assets/images/indexSHS/searchDoc.png" />
        </v-btn>

      </v-img>

      <v-img
          v-show="!$vuetify.breakpoint.smAndDown"
          src="../../../assets/images/indexSHS/hands.png"
          :max-height="$vuetify.breakpoint.smAndDown?'auto':'400'"
          contain>

        <v-btn
            fab
            middle
            right
            light
            top
            style="float: right"
            class="ml-2 mt-2 mr-2"
            @click="goClinicNo('DoctorIntroduction')"
        >
          <img  src="../../../assets/images/indexSHS/searchDoc.png" />
        </v-btn>

      </v-img>
      <!--<img width="auto" height="500px" src="../../../assets/images/indexSHS/hands.png" />-->
    </v-flex>

    <v-container :class="['xs12 sm12 md12 lg12 row wrap',$vuetify.breakpoint.smAndDown?'ml-0 mr-0':'ml-1 mr-1']">

      <v-flex :class="['xs12 sm12 md4 lg4 row wrap text-center mt-2 mb-2  shsBorder',$vuetify.breakpoint.smAndDown?'mr-0 ml-0':'mr-2 ml-3']" >

        <v-flex xs12 sm12 md12 lg12 text-center >
          <v-flex class="shsTitle text-center">
            馨蕙馨醫院
          </v-flex>

        </v-flex>

        <v-flex xs12 sm12 md12 lg12 row wrap text-center shsActionRow >
          <v-flex   xs4 sm4 md4 lg4  text-right >
            <v-btn
                small
                @click="goClinicNo(clinicTheme,'A')"
                class="btnTitle btnLeft">
              我要掛號
            </v-btn>
          </v-flex>

          <v-flex   xs4 sm4 md4 lg4  text-center >
            <v-btn
                small
                @click="goClinicNo('RegSearchCancel','A')"
                class="btnTitle btnCenter">
              查詢/取消掛號
            </v-btn>
          </v-flex>



          <v-flex  xs4 sm4 md4 lg4 pl-1 text-left >
            <v-btn
                @click="goClinicNo('ClinicNoSearch','A')"
                small
                class="btnTitle btnRight">
              看診進度
            </v-btn>

          </v-flex>




        </v-flex>

      </v-flex>

      <v-flex :class="['xs12 sm12 md4 lg4 row wrap text-center mt-2 mb-2  shsBorder',$vuetify.breakpoint.smAndDown?'mr-0 ml-0':'mr-2 ml-3']">

        <v-flex xs12 sm12 md12 lg12 text-center >
          <v-flex class="shsTitle text-center">
            博愛蕙馨醫院
          </v-flex>
          <!--max-height="250"-->

        </v-flex>

        <v-flex xs12 sm12 md12 lg12 row wrap text-center shsActionRow >
          <v-flex  xs4 sm4 md4 lg4  text-right >
            <v-btn
                small
                @click="goClinicNo(clinicTheme,'B')"
                class="btnTitle btnLeft">
              我要掛號
            </v-btn>

          </v-flex>

          <v-flex   xs4 sm4 md4 lg4  text-center >
            <v-btn
                small
                @click="goClinicNo('RegSearchCancel','B')"
                class="btnTitle btnCenter">
              查詢/取消掛號
            </v-btn>
          </v-flex>

          <v-flex  xs4 sm4 md4 lg4 pl-1 text-left>
            <v-btn
                small
                @click="goClinicNo('ClinicNoSearch','B')"
                class="btnTitle btnRight">
              看診進度
            </v-btn>

          </v-flex>

        </v-flex>

      </v-flex>

      <v-flex :class="['xs12 sm12 md4 lg4 row wrap text-center mt-2 mb-2  shsBorder',$vuetify.breakpoint.smAndDown?'mr-0 ml-0':'mr-2 ml-3']">

        <v-flex xs12 sm12 md12 lg12 text-center >
          <v-flex class="shsTitle text-center">
            彌馨診所
          </v-flex>

        </v-flex>

        <v-flex xs12 sm12 md12 lg12 row wrap text-center shsActionRow >
          <v-flex  xs4 sm4 md4 lg4  text-right >
            <v-btn
                small
                @click="goClinicNo(clinicTheme,'C')"
                class="btnTitle btnLeft">
              我要掛號
            </v-btn>

          </v-flex>

          <v-flex   xs4 sm4 md4 lg4  text-center >
            <v-btn
                small
                @click="goClinicNo('RegSearchCancel','C')"
                class="btnTitle btnCenter">
              查詢/取消掛號
            </v-btn>
          </v-flex>

          <v-flex  xs4 sm4 md4 lg4 pl-1  text-left >
            <v-btn
                small
                @click="goClinicNo('ClinicNoSearch','C')"
                class="btnTitle btnRight">
              看診進度
            </v-btn>

          </v-flex>

        </v-flex>

      </v-flex>
    </v-container>





  </v-flex>
  <!--SHS 網掛首頁 版本1-->
  <!--<v-layout xs12 sm12 md12 lg12 row wrap px-2 justify-space-around >-->
  <!--<v-carousel-->
  <!--class="elevation-3"-->
  <!--:show-arrows="true"-->
  <!--v-model="indexSelect"-->
  <!--:style="{width:$vuetify.breakpoint.smAndDown?'auto':'60vw'}"-->
  <!--&gt;-->
  <!--<v-carousel-item-->
  <!--v-for="(item, index) in indexList"-->
  <!--:key="index"-->
  <!--&gt;-->
  <!--<v-card class="indexBg xs12 sm12 md3 lg3" dark >-->

  <!--<v-flex style="height: 30px;padding-top: 10px" class="subHeader">-->

  <!--</v-flex>-->
  <!--<v-flex class="subHeader row wrap xs12 sm12 md12 lg12" style="margin-left: 0px;margin-top: 10px;width: 100%;-->
  <!--min-width: 100%;">-->
  <!--<v-flex class="text-center xs12 sm12 md12 lg12">-->
  <!--<img src="../../../assets/images/indexSHS/.png" />-->
  <!--</v-flex>-->
  <!--<v-flex class="text-center xs12 sm12 md12 lg12">-->
  <!--&lt;!&ndash;<v-img&ndash;&gt;-->
  <!--&lt;!&ndash;:src="item.imgLogo"&ndash;&gt;-->
  <!--&lt;!&ndash;lazy-src="https://picsum.photos/id/11/100/60"&ndash;&gt;-->
  <!--&lt;!&ndash;max-width="500"&ndash;&gt;-->
  <!--&lt;!&ndash;max-height="300"&ndash;&gt;-->
  <!--&lt;!&ndash;&gt;&ndash;&gt;-->
  <!--&lt;!&ndash;</v-img>&ndash;&gt;-->
  <!--<img :src="item.imgUrl" />-->
  <!--</v-flex>-->

  <!--</v-flex>-->


  <!--<v-flex style="padding: 16px">-->

  <!--<v-flex  xs12 sm12 md12 lg12 row wrap >-->

  <!--<v-flex xs12 sm12 md12 lg12 pl-4 @click="goClinicNo(clinicTheme,item.zone)">-->
  <!--<v-btn  color="shsBtn" large >  <img   src="../../../assets/images/indexSHS/.png" />我要看診</v-btn>-->
  <!--</v-flex>-->

  <!--<v-flex xs12 sm12 md12 lg12 mt-5 pl-4 @click="goClinicNo(item.clinicNo,item.zone)">-->
  <!--<v-btn  color="shsBtn" large>  <img   src="../../../assets/images/indexSHS/.png" />看診進度</v-btn>-->
  <!--</v-flex>-->

  <!--</v-flex>-->

  <!--</v-flex>-->

  <!--<v-card-actions class="subHeader" style="height: 30px">-->
  <!--<v-spacer></v-spacer>-->
  <!--</v-card-actions>-->

  <!--</v-card>-->

  <!--</v-carousel-item>-->
  <!--</v-carousel>-->
  <!--</v-layout>-->

  <!--SHS 網掛首頁 版本2-->
  <!--<v-layout xs12 sm12 md12 lg12 row wrap justify-space-around align-content-space-between>-->

  <!--<v-card class="indexBg xs12 sm12 md4 lg4 mb-3" :style="{width: $vuetify.breakpoint.smAndDown?'auto':'30%',height: $vuetify.breakpoint.smAndDown?'auto':'45vh'}" dark v-for="(item,index) in indexList" :key="index">-->

  <!--<v-flex style="height: 30px;padding-top: 10px" class="subHeader">-->

  <!--</v-flex>-->
  <!--<v-flex class="subHeader row wrap xs6 sm6 md12 lg12" style="margin-left: 0px;margin-top: 10px;width: 100%;-->
  <!--min-width: 100%;">-->
  <!--&lt;!&ndash;<v-flex class="text-center xs12 sm12 md12 lg12">&ndash;&gt;-->
  <!--&lt;!&ndash;<img src="../../../assets/images/indexSHS/.png" />&ndash;&gt;-->
  <!--&lt;!&ndash;</v-flex>&ndash;&gt;-->
  <!--<v-flex class="text-center xs12 sm12 md12 lg12">-->
  <!--<img :src="item.imgUrl" />-->
  <!--</v-flex>-->

  <!--</v-flex>-->


  <!--<v-flex style="padding: 16px">-->

  <!--<v-flex  xs12 sm12 md12 lg12 row wrap >-->

  <!--<v-flex xs12 sm12 md12 lg12 pl-4 @click="goClinicNo(clinicTheme,item.zone)">-->
  <!--<v-btn  color="shsBtn" large >-->
  <!--&lt;!&ndash;<v-icon>mdi-cursor-pointer</v-icon>&ndash;&gt;-->
  <!--<img   src="../../../assets/images/indexSHS/.png" />-->
  <!--我要看診-->
  <!--</v-btn>-->
  <!--</v-flex>-->


  <!--<v-flex xs12 sm12 md12 lg12 mt-5 pl-4 @click="goClinicNo(item.clinicNo,item.zone)">-->
  <!--<v-btn  color="shsBtn" large>  <img   src="../../../assets/images/indexSHS/.png" />看診進度</v-btn>-->
  <!--</v-flex>-->


  <!--</v-flex>-->

  <!--</v-flex>-->

  <!--<v-card-actions class="subHeader" style="height: 30px">-->
  <!--<v-spacer></v-spacer>-->
  <!--</v-card-actions>-->


  <!--</v-card>-->



  <!--</v-layout>-->




</template>

<script>
export default {
  name: "IndexSHS",
  data() {
    return {
      clinicTheme:'ClinicA',
      indexSelect:0,
    }
  },
  created(){
    this.axios_getSysTheme();
  },
  methods:{
    goClinicNo(name,zone){
      this.$router.push({name: name,query:{zone:zone}});
    },
    axios_getSysTheme (){ //查詢樣式theme設定檔
      let url = '';
      this.clinicTheme = '';
      url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

      this.$http.get(url).then(response =>{
        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
          this.clinicTheme = response.data.resultSet[0].value3;
        }else{
          this.clinicTheme = 'ClinicA';
        }


      }).catch(error =>  {
        try {
          console.log(error.response.data.status);
          this.clinicTheme = 'ClinicA';
        } catch(err) {
          this.clinicTheme = 'ClinicA';
        }

      });

    },
  }
}
</script>

<style scoped>

.btnTitle{
  font-size: 1rem!important;
}

.btnLeft{
  border-radius: 14px 14px 14px 14px!important;
  color: black;
  /*background-color: yellow!important;*/
  background-size: cover;
  background-image: url("../../../assets/images/indexSHS/regLeft.png");
}

.btnRight{
  border-radius: 14px 14px 14px 14px!important;
  color: white;
  background-size: cover;
  background-image: url("../../../assets/images/indexSHS/regClinicRight.png");
  margin-left: 15px;
  /*background-color: red!important;*/
}

.btnCenter{
  border-radius: 14px 14px 14px 14px!important;
  color: white;
  background-size: cover;
  background-image: url("../../../assets/images/indexSHS/regCancelCenter.png");
  margin-left: 10px;
}


.shsTitle{
  color:#ffffff;
  font-size: 1.5rem;
  padding-bottom: 8px;
}

.shsBorder{
  border: 1px solid white;
  padding: 15px;
}

.shsCircle{
  background: #00A1B4;
  color:#ffffff;
}

.shsIndexBg{
  background-color: #0494AC;
  /*margin-bottom: -10px;*/
  background-size: cover;
  padding: 0px;
  margin-left: 0px;
}


.subHeader{
  background-color: #98DDDF;
}

.shsBtn{
  cursor: pointer;
  background-color: #00A1B4;
  color:white;
  font-size: 1.5rem!important;
  padding: 20px;
  height: 50px!important;
  min-width: 100%!important;
}

.shsUpBg{
  background-image: url("../../../assets/images/indexSHS/upBg.png");
  background-size: cover;
}



/* 僅修正手機窄螢幕，桌機與平板維持原本樣式 */
@media (max-width: 600px) {
  .shsBorder {
    padding: 15px 4px;
  }

  /* Vuetify 的 row 預設會有左右負 margin，窄螢幕時會把按鈕推出外框 */
  .shsActionRow {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* 三欄各自保留極小間距，並取消右欄原本的 pl-1 */
  .shsActionRow > .flex {
    min-width: 0;
    box-sizing: border-box;
    padding-left: 2px !important;
    padding-right: 2px !important;
  }

  .btnTitle {
    display: flex;
    width: 100%;
    max-width: 100%;
    min-width: 0 !important;
    margin: 0 !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
    box-sizing: border-box;
    letter-spacing: 0 !important;
    white-space: nowrap;
    font-size: 0.9rem !important;
  }

  /* 「查詢/取消掛號」字數較多，手機上個別縮小 */
  .btnCenter {
    font-size: 0.72rem !important;
  }
}


</style>